import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function generalInfoModuleSelector(state: IInitialState) {
	return moduleStateSelector(state).generalInfoModule;
}
